import React from "react";
import RadioButtonGroup from "./RadioButtonGroup";

const JaNeeRadioButtonGroup = (props) => {
	const radiobuttongroupJaNee = [{ value: true, label: 'Ja' }, { value: false, label: 'Nee' }];
	props = Object.assign({}, props, {
		items: radiobuttongroupJaNee
	});

	return (
		<RadioButtonGroup {...props} />
	);
};

export default JaNeeRadioButtonGroup;
